"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseQuoteTool = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = require("react-helmet");
var _reactRouterDom = require("react-router-dom");
var _reactHookForm = require("react-hook-form");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _reactRedux = require("react-redux");
var _quoteToolContextPropTypes = require("../../types/propTypes/quoteToolContextPropTypes");
var _brandContext = require("../../contextProviders/brandContext");
var _quoteToolDataContextProvider = require("../../contextProviders/quoteToolDataContextProvider");
var _basePropTypes = require("../../types/propTypes/basePropTypes");
var _selectors = require("../../store/quote/selectors");
var _slice = require("../../store/app/slice");
var _useFormHydration = require("./useFormHydration");
var _routeStatesReducer = require("../../reducers/routeStatesReducer");
var _ErrorHandler = require("../ErrorHandler/ErrorHandler");
var _ApiKeyHandler = require("../ApiKeyHandler/ApiKeyHandler");
var _initialPet = require("../../constants/quote/initialPet");
var _emailQuotePanelContextProvider = require("../../contextProviders/emailQuotePanelContextProvider");
var _environment = require("../../helpers/environment");
var _brands = require("../../helpers/brands");
require("./quoteTool.scss");
var _constants = require("../../constants/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable react/no-array-index-key */
var getDefaultValues = function getDefaultValues(quoteData) {
  return !quoteData || !quoteData.pets || quoteData.pets.length < 1 ? _objectSpread(_objectSpread({}, quoteData), {}, {
    pets: [_initialPet.INITIAL_PET]
  }) : quoteData;
};
var BaseQuoteTool = exports.BaseQuoteTool = function BaseQuoteTool() {
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    staffMode = _useContext.staffMode,
    applyBrandContext = _useContext.applyBrandContext,
    activeBrandContext = _useContext.activeBrandContext,
    useMocks = _useContext.useMocks,
    env = _useContext.env;
  var _useContext2 = (0, _react.useContext)(_quoteToolDataContextProvider.QuoteToolDataContext),
    quoteDataContext = _useContext2.quoteData;
  var _useContext3 = (0, _react.useContext)(_emailQuotePanelContextProvider.EmailQuoteContext),
    openEmailPanel = _useContext3.openEmailPanel;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var location = (0, _reactRouterDom.useLocation)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var middlewareKeys = activeBrandContext.middlewareApiKeys;
  var mode = staffMode ? 'staff' : 'public';

  /**
   * Check if both mode and environment values are present in the
   * brand configs. Fallbacks to public mode if the staff values
   * are not present in the brand configuration.
   */
  var _ref = middlewareKeys && middlewareKeys[mode] && middlewareKeys[mode][env] ? middlewareKeys[mode][env] : middlewareKeys["public"][env],
    apiKey = _ref.apiKey,
    clientId = _ref.applicationId;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    savedQuoteData = _useSelector.quote,
    initialFetchStatus = _useSelector.metadata.initialFetchStatus;
  var quoteData = useMocks ? quoteDataContext : savedQuoteData;
  var defaultFormValues = getDefaultValues(quoteData);
  var _activeBrandContext$b = activeBrandContext.brand,
    brandKey = _activeBrandContext$b.key,
    broker = _activeBrandContext$b.broker,
    brandFullName = _activeBrandContext$b.fullName,
    styleSheet = _activeBrandContext$b.styleSheet,
    _activeBrandContext$s = activeBrandContext.seo,
    keywords = _activeBrandContext$s.keywords,
    description = _activeBrandContext$s.description,
    pageTitle = _activeBrandContext$s.title,
    _activeBrandContext$l = activeBrandContext.layout,
    bodyCssClass = _activeBrandContext$l.bodyCssClass,
    _activeBrandContext$l2 = _activeBrandContext$l.main,
    customContentTop = _activeBrandContext$l2.customContentTop,
    customContentBottom = _activeBrandContext$l2.customContentBottom,
    customCssClass = _activeBrandContext$l2.customCssClass,
    campaigns = _activeBrandContext$l.aside.campaigns,
    _activeBrandContext$s2 = activeBrandContext.steps,
    StepDefinitions = _activeBrandContext$s2.StepDefinitions,
    bannerStyle = _activeBrandContext$s2.bannerStyle,
    showCompletedStepBannerOnPage = _activeBrandContext$s2.showCompletedStepBannerOnPage;
  var formContext = (0, _reactHookForm.useForm)({
    mode: 'all',
    criteriaMode: 'all',
    reValidateMode: 'onChange',
    defaultValues: defaultFormValues
  });
  var selectedPartner = (0, _reactRedux.useSelector)(function (state) {
    return state.app.searchParams.partner;
  });

  /* eslint-disable react-hooks/exhaustive-deps */
  (0, _react.useLayoutEffect)(function () {
    /* Apply brand context based on broker */
    if (selectedPartner) {
      var brandContext = (0, _brands.GetBrandContext)(brandKey, selectedPartner);
      if (brandContext) {
        applyBrandContext(brandContext);
      }
    }
    dispatch((0, _slice.setActiveBrand)({
      brandKey: brandKey,
      apiKey: apiKey,
      clientId: clientId
    }));
  }, [selectedPartner, dispatch, brandKey, env]);
  /* eslint-enable react-hooks/exhaustive-deps */

  (0, _useFormHydration.useHydrateForm)(formContext);
  var eachPetHasSelectedPetQuote = (0, _react.useMemo)(function () {
    if (quoteData.pets.length === 0) {
      return false;
    }
    return quoteData.pets.every(function (pet) {
      var _pet$selectedQuote;
      return useMocks || pet.selectedQuote !== null && ((_pet$selectedQuote = pet.selectedQuote) === null || _pet$selectedQuote === void 0 ? void 0 : _pet$selectedQuote.planNumber);
    });
  }, [useMocks, quoteData.pets]);
  var getBannerStates = (0, _react.useCallback)(function () {
    var path = location.pathname.substring(1);
    var readOnlyCompletedStepBanner = showCompletedStepBannerOnPage === path;
    return StepDefinitions.map(function (stepDefinition, index) {
      if (readOnlyCompletedStepBanner) {
        return _objectSpread(_objectSpread({}, stepDefinition), {}, {
          isCompleted: true
        });
      }
      return _objectSpread(_objectSpread({}, stepDefinition), {}, {
        isActive: path === stepDefinition.url
      }, _routeStatesReducer.InitialRouteStates.stepStates[index]);
    });
  }, [StepDefinitions, location.pathname, showCompletedStepBannerOnPage]);
  var _useState = (0, _react.useState)(getBannerStates()),
    _useState2 = _slicedToArray(_useState, 2),
    bannerState = _useState2[0],
    setBannerState = _useState2[1];
  var handleCompletedStepClick = function handleCompletedStepClick(step) {
    if (!step.url || step.url === '') {
      return;
    }
    navigate(step.url);
  };
  var onFormSubmit = function onFormSubmit(event) {
    event.preventDefault();
  };
  (0, _react.useEffect)(function () {
    setBannerState(getBannerStates());
    if (useMocks) {
      formContext.reset(quoteDataContext);
    }
  }, [formContext, quoteDataContext, getBannerStates, useMocks, dispatch]);
  var _useWatch = (0, _reactHookForm.useWatch)({
      control: formContext.control,
      name: ['promotionCode']
    }),
    _useWatch2 = _slicedToArray(_useWatch, 1),
    promotionCode = _useWatch2[0];
  var allCampaigns = (0, _react.useMemo)(function () {
    if (typeof campaigns === 'function') {
      return campaigns({
        promoCode: promotionCode
      });
    }
    return campaigns;
  }, [campaigns, promotionCode]);
  var handleOpenEmail = function handleOpenEmail() {
    if (typeof openEmailPanel === 'function') {
      openEmailPanel();
    }
  };
  var activePath = bannerState === null || bannerState === void 0 ? void 0 : bannerState.find(function (item) {
    return item === null || item === void 0 ? void 0 : item.isActive;
  });
  return /*#__PURE__*/_react["default"].createElement(_ErrorHandler.ErrorHandler, null, /*#__PURE__*/_react["default"].createElement(_ApiKeyHandler.ApiKeyHandler, {
    apiKey: apiKey,
    clientId: clientId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "quoteToolContainer",
    className: "quoteToolContainer"
  }, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, pageTitle ? /*#__PURE__*/_react["default"].createElement("title", null, pageTitle) : /*#__PURE__*/_react["default"].createElement("title", null, brandFullName, " Pet Insurance"), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "keywords",
    content: keywords
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/_react["default"].createElement("body", {
    className: "react petSure quoteTool ".concat(bodyCssClass, " ").concat(styleSheet)
  })), /*#__PURE__*/_react["default"].createElement(_reactHookForm.FormProvider, formContext, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: onFormSubmit,
    autoComplete: "one-time-code",
    className: "petSureForm verticalStacked"
  }, /*#__PURE__*/_react["default"].createElement("main", {
    className: customCssClass || ''
  }, /*#__PURE__*/_react["default"].createElement(_components.StepsBanner, {
    onCompletedStepClick: handleCompletedStepClick,
    bannerStyle: bannerStyle,
    steps: bannerState
  }), customContentTop, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_components.Spinner, null)
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Outlet, {
    context: {
      stepDefinitions: StepDefinitions,
      pets: quoteData.pets,
      owner: quoteData.owner,
      formContext: formContext
    }
  })), customContentBottom))), allCampaigns && allCampaigns.length > 0 && /*#__PURE__*/_react["default"].createElement("aside", {
    className: "campaigns"
  }, allCampaigns.map(function (campaign, index) {
    if (typeof campaign.props.campaignImageUrl === 'function' && campaign.props.__type === 'CampaignHolder') {
      var campaignProps = _objectSpread(_objectSpread({}, campaign.props), {}, {
        campaignBaseUrl: (0, _environment.GetCDNBaseURL)({
          env: env,
          defaultBase: campaign.campaignBaseUrl
        })
      });
      return /*#__PURE__*/_react["default"].createElement("section", {
        key: "".concat(activeBrandContext.brand.key, "_campaign_").concat(index),
        className: "campaign"
      }, /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, campaignProps));
    }
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: "".concat(activeBrandContext.brand.key, "_campaign_").concat(index),
      className: "campaign"
    }, campaign);
  }), eachPetHasSelectedPetQuote && activePath && !(activePath !== null && activePath !== void 0 && activePath.hideEmailQuoteButton) && initialFetchStatus !== _constants.STATUS_PENDING && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return handleOpenEmail();
    },
    type: "button",
    className: "button text_only"
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "email"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Email me this quote"))))));
};
BaseQuoteTool.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  brandQuoteToolContext: _propTypes["default"].any,
  // eslint-disable-next-line react/forbid-prop-types
  quoteToolLayoutContext: _propTypes["default"].any,
  brandContext: _quoteToolContextPropTypes.QuoteToolContextProps,
  savedPets: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape(_basePropTypes.PetDetailsPropType)])),
  activeStep: _propTypes["default"].number,
  savedOwner: _propTypes["default"].shape(_basePropTypes.OwnerDetailsQuotePropType),
  useMocks: _propTypes["default"].bool
};